import { app, translate } from '../app'
import { Container } from './container'
import { languages } from '../locale'
import { useAnimateOnScroll } from './useAnimateOnScroll'
import { shiftHexColorDown, getTailwindStyles } from '../helpers';
import { SplitText } from "./splittext";

export function BlockText(props: { block: BlockText }) {
  const isRTL = languages[app.locale]?.rtl

  useAnimateOnScroll()

  const { block } = props
  const { bgColorClass, textColorClass, fontWeightClass } = getTailwindStyles(block);
  
  return (
      <div style={{border: `1px solid ${shiftHexColorDown(block.textcolor)}`}} className={`block-text ${bgColorClass} ${textColorClass}`}>
        <Container>
        <p
          className={`fade-up-0 text-lg ${fontWeightClass} leading-relaxed !m-0 ${isRTL ? 'text-right' : 'text-left'}`}
          style={{ direction: isRTL ? "rtl" : "ltr" }}
          data-animation='animate__fadeInUp'
        >
          <SplitText text={translate(block.text)} />
        </p>
        </Container>
      </div>
  )
}
